export default __webpack_public_path__ + "static/media/90s_block_rotate.8ad8a603.mp3";